module.exports = __webpack_public_path__ + "static/img/guild.222c56dd.png";